import { Typography } from 'antd';
import {
  SidebarPortal,
  SidebarContainer,
  SidebarDivider,
  SidebarScrollContainer,
} from 'layouts/DashboardLayout/Sidebar';
import AdminSidebar from './AdminSidebar';

const AdminPortalLayout = ({ children }) => {
  return (
    <>
      <SidebarPortal>
        <SidebarContainer>
          <Typography.Title
            level={5}
            style={{
              margin: 0,
            }}
          >
            Admin Tools
          </Typography.Title>
          <SidebarDivider />
        </SidebarContainer>

        <SidebarScrollContainer>
          <AdminSidebar />
        </SidebarScrollContainer>
      </SidebarPortal>

      {children}
    </>
  );
};

export default AdminPortalLayout;
